import styled, { css } from "styled-components";
import { breakpoints } from "../../../../../../shared-logic/themes/toyotaTheme";

export const Card = styled.div`
    padding: var(--spacing-2);
    background: var(--color-grey-1);
    border-top: 1px solid var(--color-grey-4);
    border-radius: 0 0 4px 4px;
    @media screen and (min-width: ${breakpoints.md}) {
        padding: var(--spacing-3);
    }
`;

export const Description = styled.div`
    padding: var(--spacing-2);
    font-family: var(--font-book);
    font-size: 1.6rem;
    color: var(--color-primary-black);
    background: var(--color-primary-white);
    @media screen and (min-width: ${breakpoints.md}) {
        padding: var(--spacing-3);
    }
`;

export const SpecList = styled.ul`
    display: grid;
    gap: var(--spacing-1);
    margin-bottom: var(--spacing-2);
    padding-inline-start: 0;

    @supports not (padding-inline-start: 0) {
        padding-left: 0;
        padding-right: 0;
    }

    @media screen and (min-width: ${breakpoints.md}) {
        grid-template-columns: repeat(3, 1fr);
    }
    @media screen and (min-width: ${breakpoints.xxl}) {
        gap: var(--spacing-3);

        @supports not (gap: var(--spacing-3)) {
            grid-column-gap: var(--spacing-3);
        }
    }
`;

export const SpecItem = styled.li`
    display: flex;
    align-items: center;
    gap: calc(var(--spacing-3) / 2);
    padding: calc(var(--spacing-3) / 2) var(--spacing-2);
    font-family: var(--font-regular);
    font-size: 1.6rem;
    line-height: 2.4rem;
    background: var(--color-primary-white);
    border: 1px solid var(--color-grey-6);
    border-radius: 4px;
    svg {
        vertical-align: middle;
    }

    @supports not (gap: calc(var(--spacing-3) / 2)) {
        svg {
            margin-right: calc(var(--spacing-3) / 2);
        }
    }
`;

export const YearSeparator = styled.time`
    --separator-color: var(--color-grey-6);

    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    margin: var(--spacing-2) 0;
    text-align: center;
    @media screen and (min-width: ${breakpoints.md}) {
        margin: var(--spacing-3) 0;
    }
    span {
        padding: calc(var(--spacing-1) / 2) var(--spacing-1);
        font-family: var(--font-regular);
        font-size: 1.3rem;
        color: var(--color-grey-7);
        border: 1px solid var(--separator-color);
        border-radius: 0.3rem;
    }
    &::before,
    &::after {
        height: 1px;
        content: "";
        background: var(--separator-color);
    }
`;

export const Event = styled.div<{ showBorder?: boolean }>`
    margin: var(--spacing-2) 0;
    padding: var(--spacing-2);
    background: var(--color-primary-white);
    border-radius: 4px;
    box-shadow: var(--dropshadow-md);
    border-inline-start: 4px solid var(--color-grey-6);
    @media screen and (min-width: ${breakpoints.md}) {
        margin: var(--spacing-3) 0;
    }

    @supports not (padding-inline: 0) {
        border-left: 4px solid var(--color-grey-6);
    }

    ${({ showBorder }) =>
        showBorder &&
        css`
            border-inline-start-color: var(--color-primary-red);
            @media screen and (min-width: ${breakpoints.md}) {
                margin-top: var(--spacing-2);
            }

            @supports not (padding-inline: 0) {
                border-left-color: var(--color-primary-red);
            }
        `};
`;

export const EventHeader = styled.div`
    display: flex;
    justify-content: space-between;
    gap: var(--spacing-2);
    margin-bottom: var(--spacing-1);
`;

export const EventTitle = styled.h5`
    margin: 0;
    font-family: var(--font-regular);
    font-size: 1.6rem;
    line-height: 2.4rem;
`;

export const EventMileagePoint = styled.div`
    color: var(--color-grey-7);
`;

export const EventOfficialDealer = styled.div`
    margin: var(--spacing-1) 0 0;
    padding: var(--spacing-1) 0 0;
    font-family: var(--font-book);
    font-size: 1.3rem;
    line-height: 2rem;
    color: var(--color-grey-7);
    border-top: 1px solid var(--color-grey-4);
`;

export const ShowMore = styled.button<{ rotateIcon?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: calc(var(--spacing-1) / -1);
    font-size: 1.3rem;
    line-height: 2rem;
    color: var(--color-primary-black);
    cursor: pointer;
    user-select: none;

    svg {
        color: inherit;
        transition: transform 0.3s;
        vertical-align: middle;
        ${({ rotateIcon }) => css`
            margin-inline-start: var(--spacing-1);
            color: var(--color-primary-red);
            transform: rotate(${rotateIcon ? 180 : 0}deg);
        `};
    }
`;
